export default "__VITE_ASSET__DVKVRk4p__"